export const getMediaFileId = (media) => {
	if (!media) {
		return null;
	}

	if (typeof media === 'string') {
		return media;
	}

	const rawId = media._id ?? media.id;
	if (!rawId) {
		return null;
	}

	if (typeof rawId === 'string') {
		return rawId;
	}

	if (typeof rawId === 'object' && typeof rawId.toString === 'function') {
		return rawId.toString();
	}

	return String(rawId);
};

export const getMediaDirectSrc = (media) => {
	if (!media || typeof media !== 'object') {
		return null;
	}

	return media.base64 || media.url || null;
};
